import { ChevronLeft, ChevronRight } from "lucide-react";

export function NextArrow(props: {
  className?: string;
  style?: Record<string, string>;
  onClick: () => void;
}) {
  const { className, style, onClick } = props;

  return (
    <button
      className={`${className} custom-arrow custom-next-arrow rounded-full w-12 h-12 bg-white inline-flex justify-center items-center -mr-3.5`}
      style={{
        ...style,
      }}
      onClick={onClick}
    >
      <ChevronRight size={30} color="black" />
    </button>
  );
}

export function PrevArrow(props: {
  className?: string;
  style?: Record<string, string>;
  onClick: () => void;
}) {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} custom-arrow custom-prev-arrow  rounded-full w-12 h-12 bg-white inline-flex justify-center items-center -ml-3.5`}
      style={{
        ...style,
      }}
      onClick={onClick}
    >
      <ChevronLeft size={30} color="black" />
    </div>
  );
}
